// Shared money formatting for the Notices surface. Amounts are MINOR units
// (öre / cents). Falls back to a plain "12.00 SEK" when Intl can't handle the
// currency code.
export function formatMinor(minor: number, currency: string, locale: string): string {
  const cur = currency || 'SEK';
  try {
    return new Intl.NumberFormat(locale || 'sv-SE', {
      style: 'currency',
      currency: cur,
    }).format(minor / 100);
  } catch {
    return `${(minor / 100).toFixed(2)} ${cur}`;
  }
}
